import createApi from './api';

export default class BookmarksService {
  constructor() {
    this.api = createApi({
      baseUrl: `/bookmarks`,
      headers: {
        'Content-Type': 'application/json'
      },
    });
  }

  async loadAll() {
    return this.api.get('list');
  }

  async add(params) {
    return this.api.post('add', params);
  }

  async remove(params) {
    return this.api.post('remove', params);
  }
}
